import { computed } from 'vue';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasFahrradDiebstahlAndRequiresAmountReactive,
  hasGlasversicherung,
} from '@/features/Sparten/hau/formConfigs/sharedRenderConditions';

export const hasNoFahrradSumme: ConditionalRequestDefinition = {
  if: computed(() => !hasFahrradDiebstahlAndRequiresAmountReactive.value),
  drop: ['fahrradsumme'],
};

export const hasNoGlasversicherung: ConditionalRequestDefinition = {
  if: computed(() => !hasGlasversicherung.value),
  drop: ['ceran'],
};

export const temporaryField: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: ['temporaryInputFields'],
};

export const hauInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  hasNoFahrradSumme,
  hasNoGlasversicherung,
  temporaryField,
];
